export const SEARCH_TITLE = "Selling Sunsets Dehradun | Property Intelligence for Uttarakhand";
export const SEARCH_DESCRIPTION = "Selling Sunsets, based in Dehradun, offers independent property intelligence and buyer advisory for Dehradun, Mussoorie and Uttarakhand.";
export const BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://sellingsunsets.co.in/#organization",
  name: "Selling Sunsets",
  url: "https://sellingsunsets.co.in/",
  description: SEARCH_DESCRIPTION,
  telephone: "+91 78952 32868",
  email: "hi@sellingsunsets.co.in",
  logo: "https://sellingsunsets.co.in/brand/png/ss-primary-ink-2400w.png",
  address: { "@type": "PostalAddress", addressLocality: "Dehradun", addressRegion: "Uttarakhand", addressCountry: "IN" },
  areaServed: { "@type": "AdministrativeArea", name: "Uttarakhand, India" }
};
